import localeAntd from "ant-design-vue/lib/locale-provider/en_US";

const messages = {
  topBar: {
    issuesHistory: "Issues History",
    projectManagement: "Project Management",
    typeToSearch: "Search...",
    findPages: "Find pages...",
    actions: "Actions",
    status: "Status",
    profileMenu: {
      hello: "Hello",
      billingPlan: "Billing Plan",
      role: "Role",
      email: "Email",
      phone: "Phone",
      editProfile: "Edit Profile",
      logout: "Logout",
    },
  },
  authPage: {
    welcomeTo: "Welcome to ",
    singinToAccount: "Sign in to your account",
    plzInputYourName: "Please input your username",
  },
};

// Custom format Date
const dateTimeFormats = {
  short: {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  },
  long: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
  },
};

export default {
  locale: "en-US",
  localeAntd,
  messages,
  dateTimeFormats,
};
